export default __webpack_public_path__ + "static/media/lv10.8afb75e4.png";